import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6114e8fb")

_pushScopeId("data-v-6114e8fb")
const _hoisted_1 = {
  class: "container providers-page",
  id: "providers"
}
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = { class: "d-lg-flex" }
const _hoisted_4 = { class: "providers-actions order-lg-1 col-lg-2 mb-lg-0 justify-content-center justify-content-lg-end" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_6 = { class: "providers-search col-lg-5 mt-auto" }
const _hoisted_7 = { class: "search-button-wrapper pl-15" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_9 = { class: "providers-total-filter col-lg-5 mt-auto px-lg-2" }
const _hoisted_10 = {
  class: "providers-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_11 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "providers-filter-circle"
}
const _hoisted_14 = {
  key: 0,
  class: "mobile-grid"
}
const _hoisted_15 = { class: "header-line" }
const _hoisted_16 = { style: {"display":"flex","align-items":"center","column-gap":"5px"} }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-external-link fs-22" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "status-green"
}
const _hoisted_19 = {
  key: 1,
  class: "status-red"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_21 = { class: "mobile-table-info-card" }
const _hoisted_22 = { class: "details-row" }
const _hoisted_23 = { class: "details-row" }
const _hoisted_24 = { class: "details-row" }
const _hoisted_25 = { class: "details-row" }
const _hoisted_26 = { class: "link-color" }
const _hoisted_27 = { class: "details-row" }
const _hoisted_28 = { class: "link-color" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-20" }, null, -1)
const _hoisted_30 = {
  key: 1,
  class: "desktop-grid"
}
const _hoisted_31 = { class: "w100" }
const _hoisted_32 = { class: "thead-cell-center" }
const _hoisted_33 = {
  class: "text-center",
  style: {"width":"4%"}
}
const _hoisted_34 = { class: "desktop-table-action" }
const _hoisted_35 = { class: "thead-cell-center" }
const _hoisted_36 = { class: "desktop-table-text-setting" }
const _hoisted_37 = { class: "desktop-table-text-setting" }
const _hoisted_38 = { class: "desktop-table-text-setting" }
const _hoisted_39 = { class: "desktop-table-text-setting" }
const _hoisted_40 = { class: "desktop-table-text-setting text-center" }
const _hoisted_41 = {
  class: "desktop-table-text-setting",
  style: {"padding-inline-start":"10px"}
}
const _hoisted_42 = { class: "cuted-cell" }
const _hoisted_43 = { class: "desktop-table-text-setting" }
const _hoisted_44 = { class: "desktop-table-text-setting" }
const _hoisted_45 = { class: "desktop-table-text-setting" }
const _hoisted_46 = { class: "desktop-table-text-setting text-center" }
const _hoisted_47 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-external-link fs-22" }, null, -1)
const _hoisted_48 = { class: "desktop-table-text-setting" }
const _hoisted_49 = {
  key: 0,
  class: "status-green"
}
const _hoisted_50 = {
  key: 1,
  class: "status-red"
}
const _hoisted_51 = { class: "desktop-table-action text-center" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.providers')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          type: "button",
          class: "provider-circle-btn btn-orange mx-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ProvidersForToday()))
        }, _toDisplayString(_ctx.$t('providers.providersForToday')), 1),
        _createVNode(_component_router_link, {
          to: { name: 'provider-new' },
          class: "provider-circle-btn btn-lred flex-center"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('button.newProvider')), 1)
          ]),
          _: 1
        }),
        _createVNode("button", {
          type: "button",
          class: "provider-circle-btn btn-green mx-1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Export()))
        }, [
          _hoisted_5,
          _createVNode("div", null, _toDisplayString(_ctx.$t('report.export')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _withDirectives(_createVNode("input", {
          class: "bookit-input provider-input w100",
          id: "datetime",
          type: "text",
          placeholder: _ctx.$t('providers.searchPlaceholder'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.keyword = $event)),
          onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
        }, null, 40, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search()))
          }, [
            _hoisted_8
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('providers.totalFiltered')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('providers.ofProviders', { total: _ctx.total })), 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["providers-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            type: "button",
            class: "providers-filter-btn-text",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_12
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_13, "!"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    (_ctx.isMobileView && _ctx.rows.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "provider-item",
              key: index
            }, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'provider-view', params: { id: row.id } }
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(row.id), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("a", {
                    class: ["link-icon m-0", !row.isActive ? 'link-disabled' : ''],
                    target: "_blank",
                    href: row.isActive ? row.pmsLink : ''
                  }, [
                    _hoisted_17
                  ], 10, ["href"]),
                  (row.isActive)
                    ? (_openBlock(), _createBlock("span", _hoisted_18, "ACTIVE"))
                    : (_openBlock(), _createBlock("span", _hoisted_19, "NOT ACTIVE"))
                ])
              ]),
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('providers.name')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(row.name), 1)
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('providers.company')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(row.companyName), 1)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('providers.products')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(row.productsQty), 1)
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('providers.mobile')) + ": ", 1),
                  _createVNode("span", _hoisted_26, [
                    (row.mobile)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "text-link m-0",
                          href: 'tel:' + row.mobile
                        }, _toDisplayString(row.mobile), 9, ["href"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('providers.email')) + ": ", 1),
                  _createVNode("span", _hoisted_28, [
                    (row.email)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "text-link m-0",
                          href: 'mailto:' + row.email
                        }, _toDisplayString(row.email), 9, ["href"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'provider-view', params: { id: row.id } },
                  class: "btn-edit"
                }, {
                  default: _withId(() => [
                    _hoisted_29
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobileView)
      ? (_openBlock(), _createBlock("div", _hoisted_30, [
          _createVNode("table", _hoisted_31, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy('Id'))),
                  style: {"width":"11%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.id')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Id')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBy('Name'))),
                  style: {"width":"12%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.name')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Name')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortBy('YtourId'))),
                  style: {"width":"7%"},
                  class: "text-center"
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.YtourId')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('YtourId')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortBy('CrmId'))),
                  style: {"width":"7%"},
                  class: "text-center"
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.CrmId')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CrmId')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortBy('ProductQty'))),
                  style: {"width":"4%"}
                }, [
                  _createVNode("span", _hoisted_32, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.products')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProductQty')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortBy('CompanyName'))),
                  style: {"width":"14%","padding-inline-start":"10px"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.company')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CompanyName')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortBy('CompanyId'))),
                  style: {"width":"10%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.companyId')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CompanyId')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortBy('Email'))),
                  style: {"width":"15%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.email')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Email')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortBy('Mobile'))),
                  style: {"width":"10%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.mobile')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Mobile')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", _hoisted_33, _toDisplayString(_ctx.$t('providers.pms')), 1),
                _createVNode("td", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sortBy('IsActive'))),
                  style: {"width":"8%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.isActive')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('IsActive')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", _hoisted_34, [
                  _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('customerType.actions')), 1)
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_36, [
                    _createVNode(_component_router_link, {
                      to: { name: 'provider-view', params: { id: row.id } },
                      class: "text-link m-0"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.id), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_37, [
                    _createVNode(_component_router_link, {
                      to: { name: 'provider-view', params: { id: row.id } },
                      class: "text-link cuted-cell m-0"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_38, _toDisplayString(row.ytourId), 1),
                  _createVNode("td", _hoisted_39, _toDisplayString(row.crmId), 1),
                  _createVNode("td", _hoisted_40, [
                    _createVNode("span", null, _toDisplayString(row.productsQty), 1)
                  ]),
                  _createVNode("td", _hoisted_41, [
                    _createVNode("span", _hoisted_42, _toDisplayString(row.companyName), 1)
                  ]),
                  _createVNode("td", _hoisted_43, _toDisplayString(row.companyId), 1),
                  _createVNode("td", _hoisted_44, [
                    (row.email)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "text-link cuted-cell m-0",
                          href: 'mailto:' + row.email
                        }, _toDisplayString(row.email), 9, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_45, [
                    (row.mobile)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "text-link m-0",
                          href: 'tel:' + row.mobile
                        }, _toDisplayString(row.mobile), 9, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_46, [
                    _createVNode("a", {
                      class: ["link-icon m-0", !row.isActive ? 'link-disabled' : ''],
                      target: "_blank",
                      href: row.isActive ? row.pmsLink : ''
                    }, [
                      _hoisted_47
                    ], 10, ["href"])
                  ]),
                  _createVNode("td", _hoisted_48, [
                    (row.isActive)
                      ? (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(_ctx.$t('label.active')), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('label.notactive')), 1))
                  ]),
                  _createVNode("td", _hoisted_51, [
                    _createVNode(_component_router_link, {
                      to: { name: 'provider-view', params: { id: row.id } },
                      class: "m-0"
                    }, {
                      default: _withId(() => [
                        _hoisted_52
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})